// components/AI_Chat/ToolSelectDialog.tsx — utilise les styles .tool-dialog-* déjà présents dans modern-chat.scss
import React, { useState } from "react";
import { ReactComponent as IconTool } from "assets/img/icons/settings.svg";

// Clés alignées sur le mapping tool_choice backend (assistant.service.ts) : ID_Verify / ID_Assistant / ID_Verify_Identity forcent une fonction ; les autres restent en 'auto'
export const TOOL_LABELS: { [key: string]: string } = {
  ID_Verify: "Vérifier un document",
  ID_Assistant: "Accompagnement fraude",
  ID_Verify_Identity: "Vérifier un interlocuteur",
  ID_Tracker: "ID Tracker",
  Filigrane: "Filigrane",
  ID_Locker: "ID Locker",
};

const TOOL_DESCRIPTIONS: { [key: string]: string } = {
  ID_Verify: "Analyser l'authenticité d'un document envoyé",
  ID_Assistant: "Être accompagné après une fraude ou usurpation",
  ID_Verify_Identity: "Vérifier l'identité d'une personne (email, téléphone)",
  ID_Tracker: "Protéger vos pièces d'identité",
  Filigrane: "Filigraner un document",
  ID_Locker: "Stocker vos documents en sécurité",
};

// Texte prérempli dans le champ de saisie quand l'outil est sélectionné
export const TOOL_PREFILL: { [key: string]: string } = {
  ID_Verify: "Je souhaite vérifier l'authenticité d'un document. Je vous l'envoie en pièce jointe.",
  ID_Assistant: "J'ai été victime d'une fraude ou d'une usurpation, j'ai besoin d'un accompagnement.",
  ID_Verify_Identity: "Je souhaite vérifier un interlocuteur. Voici ses informations (nom, prénom, email, téléphone) : ",
  ID_Tracker: "Comment protéger mes pièces d'identité avec ID Tracker ?",
  Filigrane: "Je souhaite apposer un filigrane sur un document.",
  ID_Locker: "Comment stocker mes documents en sécurité avec ID Locker ?",
};

interface ToolSelectDialogProps {
  selected: string | null;
  onSelect: (tool: string | null) => void;
  onClose: () => void;
}

const ToolSelectDialog = ({ selected, onSelect, onClose }: ToolSelectDialogProps) => {
  const [pending, setPending] = useState<string | null>(selected);

  return (
    <div className="tool-dialog-overlay" onClick={onClose}>
      <div className="tool-dialog-modern" onClick={(e) => e.stopPropagation()}>
        <h3>Choisir un outil</h3>
        <div className="tool-options">
          {Object.entries(TOOL_LABELS).map(([key, label]) => (
            <div
              key={key}
              className={`tool-option${pending === key ? " selected" : ""}`}
              role="radio"
              aria-checked={pending === key}
              onClick={() => setPending(pending === key ? null : key)}
            >
              <span className="tool-radio" />
              <span className="tool-icon">
                <IconTool width={16} height={16} />
              </span>
              <div>
                <div className="tool-name">{label}</div>
                <div className="tool-desc">{TOOL_DESCRIPTIONS[key]}</div>
              </div>
            </div>
          ))}
        </div>
        <div className="dialog-actions">
          <button type="button" className="cancel-btn" onClick={onClose}>
            Annuler
          </button>
          <button type="button" className="confirm-btn" onClick={() => onSelect(pending)}>
            Confirmer
          </button>
        </div>
      </div>
    </div>
  );
};

export default ToolSelectDialog;
